'use client'
import React, { useEffect } from 'react'

// import '@fancyapps/ui/dist/fancybox/fancybox.css'
import '@fancyapps/ui/dist/fancybox.css'

import AOS from 'aos'
import 'aos/dist/aos.css'
import { toast } from 'react-toastify'
import { usePathname } from 'next/navigation'

export default function InitEffects() {
  const pathname = usePathname()

  useEffect(() => {
    const timer = setTimeout(() => {
      import('@fancyapps/ui').then(({ Fancybox }) => {
        Fancybox.bind('[data-fancybox]', {
          Thumbs: {
            type: null
          },
          Toolbar: true
        })
      })

      return () => Fancybox.destroy()
    }, 500)

    AOS.init({
      duration: 1000,
      once: true
    })

    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname])

  return null
}
